var isDev = location.href.indexOf("localhost:") !== -1;
var isSITUAT = location.href.indexOf("-sit") !== -1 || location.href.indexOf("-uat") !== -1;

function createCookie(name, value, days) {
  Cookies.set(name, value, {
    path: "/",
    domain: isDev ? "localhost" : window.location.hostname.match(/\w*\.\w*$/gi)[0],
  });
}

function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const variables = query.split("&");
  for (var i = 0; i < variables.length; i++) {
    var pair = variables[i].split("=");
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log("Query variable %s not found", variable);
}

$(document).ready(function () {
  const result = window.location.origin;
  $("[data-webName]").text(result);

  if ($(".multilang-promoterms-wrapper").length !== 0) {
    const localeCookie = getQueryVariable("language") || Cookies.get("_locale_");
    let langCode = "vi";

    /** Determine langCode
     *  Create default language cookie 'vi' if cookie doesn't exist
     * */
    if (localeCookie) {
      if (localeCookie.includes("en")) {
        langCode = "en";
      } else if (localeCookie.includes("zh")) {
        langCode = "zh";
      } else {
        langCode = "vi";
      }
    } else {
      createCookie("_locale_", "vi_VN");
    }

    /** Display container based on language */
    $(`[data-lang=${langCode}]`).css({ display: "block" });
    let currentLang = $(`#selectLang .language-option[data-value=${langCode}]`).clone();
    $(".language-wrapper .current-language").html(currentLang);

    /** Change language */
    $(".current-language").on("click", function () {
      if ($(".language-option-wrapper").hasClass("show")) {
        $(".language-option-wrapper").removeClass("show");
      } else {
        $(".language-option-wrapper").addClass("show");
      }
    });

    $("#selectLang .language-option").on("click", function () {
      const language = $(this).data("value");
      switch (language) {
        case "en":
          createCookie("_locale_", "en_US");
          break;
        case "zh":
          createCookie("_locale_", "zh_CN");
          break;
        default:
          createCookie("_locale_", "vi_VN");
      }
      $(".language-option-wrapper").removeClass("show");
      location.reload();
    });
  }
});
